/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from "@mui/material";
import { FC, Fragment, useContext } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { FormContainer } from "../../../../../shared/components/formContainer";
import { ZSAutocomplete } from "../../../../../shared/components/autoComplete";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { ZSSelectBox } from "../../../../../shared/components/selectBox";
import { Gender } from "../../../../../shared/enum";
import { Role } from "../../../../../shared/interfaces/role";
// import { customizeValidationSchema } from "../variables/customSchema";
import { getTextFields } from "../variables/textFields";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";
import { customizeValidationSchema } from "../variables/customSchema";
import { useNavigate } from "react-router";

const UserCreate: FC = () => {
  const { payload, setPayload } = useContext(SidebarContext);
  const navigate = useNavigate();

  const { loading: apiLoading, modifyData } = useMutation(
    "/user-controls/users"
  );

  //Fetching and formatting role data
  const { data } = useQuery("/admin/roles", {
    params: {
      ...payload,
      take: 25,
      sortOrder: "ASC",
      enabled: true,
    },
  });

  const rolesData: Role[] = (data as any)?.items || [];

  const roles = rolesData?.map((role: Role) => ({
    value: role.id,
    label: role.name,
  }));
  //#End of Fetching and formatting role data

  const textFields = getTextFields({}); //Get textboxes

  const initialValues = {
    fullName: "",
    email: "",
    phone: "",
    password: "",
    roleID: "",
    gender: null,
  };

  const usersForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema,
    onSubmit: async (formData: any) => {
      modifyData(
        `admin/administrators`,
        "post",
        {
          ...formData,
        },
        usersForm
      );
    },
  });

  const closeUserCreate = () => {
    navigate('/user-controls/users')
  };

  const titleBar = {
    headerTitle: "User - Create",
    title: "Create User",
    buttonTitle: "Save",
    onClick: () => usersForm.handleSubmit(),
    dirty: usersForm.dirty,
    buttonLoading: apiLoading,
    editCloseIcon: {
      visible: true,
      onClick: () => closeUserCreate(),
    },
  };

  return (
    <>
      <ProfileBorderBox>
        <FormContainer titleBar={titleBar}>
          <Box className="border-custom">
            <Grid
              paddingTop={3}
              container
              alignItems="stretch"
              columnSpacing={4}
              rowSpacing={2}
            >
              {textFields.map((field: any, index: number) => (
                <Fragment key={field.id}>
                  {(field?.formField === undefined ||
                    field.formField === true) && (
                      <Grid item md={6} sm={6} xs={12}>
                        <InputTextfield
                          form={usersForm}
                          fieldProps={field}
                          key={index}
                        />
                      </Grid>
                    )}
                </Fragment>
              ))}
              <Grid item md={6} sm={6} xs={12}>
                <ZSAutocomplete
                  options={roles}
                  placeholder="Select Role"
                  label="Role"
                  required
                  setValue={(selectedOption: any) => {
                    usersForm.setFieldTouched("roleID", true);
                    if (selectedOption?.value) {
                      usersForm.setFieldValue("roleID", selectedOption?.value);
                    } else {
                      usersForm.setFieldValue("roleID", "");
                    }
                  }}
                  setBlur={() => {
                    usersForm.setFieldTouched("roleID", true);
                  }}
                  form={{ ...usersForm, name: "roleID" }}
                  refetchFunction={(searchString: string) => {
                    setPayload((prevData: any) => {
                      return { ...prevData, search: searchString };
                    });
                  }}
                />
              </Grid>
              <Grid item md={6} sm={6} xs={12}>
                <ZSSelectBox
                  fieldProps={{
                    id: "user-gender",
                    name: "gender",
                    placeholder: "Select Gender",
                    label: "Gender",
                    required: true,
                  }}
                  options={[
                    { label: Gender.Male, value: Gender.Male },
                    { label: Gender.Female, value: Gender.Female },
                    { label: Gender.Other, value: Gender.Other },
                  ]}
                  form={usersForm}
                  value={usersForm.values?.gender}
                />
              </Grid>
            </Grid>
          </Box>
        </FormContainer>
      </ProfileBorderBox>
    </>
  );
};
export default UserCreate;
